import { Component } from '@angular/core';

@Component({
  selector: 'div[app-banner]',
  templateUrl: './banner.component.html'
})
export class BannerComponent {
  constructor() {}
}
